import {shallowRef} from 'vue';
import LtdChart from '@/components/Charts/LtdChart.vue';
import CfdChart from '@/components/Charts/CfdChart.vue';

const route = shallowRef({
    component: null,
    path: null,
});

const routes = [
    {
        name: 'ltd',
        path: '/ltd',
        component: LtdChart,
    },
    {
        name: 'cfd',
        path: '/cfd',
        component: CfdChart,
    },
];

export const useRouter = () => {
    const windowPath = window.location.pathname;
    const activeRoute = routes.find((item) => {
        return windowPath.includes(item.path);
    });

    route.value = activeRoute ?? null;

    return {
        route,
    };
};
